/**
 * ฟีเจอร์ที่เปิดให้บางบริษัทเท่านั้น
 *
 * ทำไมต้องมี: ฟีเจอร์กลุ่มนี้ต้องเข้าไปดึงข้อมูลจาก "ระบบหลังบ้านของบริษัทนั้น"
 * ซึ่งแต่ละบริษัทคนละเว็บ หน้าตาคนละแบบ ต้องเขียนตัวเชื่อม (provider) แยกกัน
 * บริษัทที่ยังไม่มีตัวเชื่อม ถ้าปล่อยให้เห็นเมนูก็กดเข้าไปเจอแต่ error
 *
 * ═══ เปิดให้บริษัทใหม่ยังไง ═══
 * 1) ฝั่ง backend เขียน provider แล้วลงทะเบียนที่
 *    BackEnd/src/api/v1/mgbMember/providers/index.js
 * 2) เติม company id ลงอาร์เรย์ข้างล่างนี้
 * แค่นี้จบ ไม่ต้องแก้เมนู/หน้าจอ/customfield ที่ไหนอีก
 */
export const COMPANY_FEATURES = {
  // หน้า User Data + ปุ่มดึงข้อมูลสมาชิกมาลงตาราง user_banks
  userData: ['6'],
  // เมนูเช็คข้อมูลกิจกรรม > โปรวันเกิด + customfield "เช็คโปรวันเกิด" ในหน้าจัดการเคส
  birthdayPromo: ['6'],
  // เมนู "เคสจาก LINE" — เฉพาะบริษัทที่ตั้ง LINE OA แล้ว (Admin → LINE OA)
  // เปิด LINE ให้บริษัทไหนเพิ่ม ต้องเติม id ที่นี่ด้วย ไม่งั้นเคส LINE ที่ถูกตีกลับจะไม่มีใครเห็น
  // (เคสพวกนี้ถูกเอาออกจากหน้า Input แล้ว)
  lineCase: ['5'],
};

// customfield.type ตัวไหนผูกกับฟีเจอร์ไหน (type ที่ไม่อยู่ในนี้ = ใช้ได้ทุกบริษัท)
export const CUSTOMFIELD_TYPE_FEATURE = {
  7: 'birthdayPromo',
};

const activeCompanyId = () => String(sessionStorage.getItem('activeCompanyId') || '');

export const hasCompanyFeature = (feature, companyId = activeCompanyId()) => {
  if (!feature) return true;
  const allowed = COMPANY_FEATURES[feature];
  if (!allowed) return true; // ไม่ได้ประกาศไว้ = ไม่จำกัดบริษัท
  return allowed.includes(String(companyId));
};
